var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { actions as formActions } from 'react-redux-form';
import { withRouter } from "../componentWrappers";
import RouteHandler from "../App/RouteHandler";
import EntitiesAPI from "../Entities/EntitiesAPI";
import { actions } from "../BasicReducer";
import * as relationships from "../Relationships/utils/routeUtils";
import { showTab } from "../Entities/actions/uiActions";
import { trackPage } from "../App/GoogleAnalytics";
import { ErrorBoundary } from "../V2/Components/ErrorHandling";
import { PDFViewComponent } from "./PDFView";
import EntityView from "./EntityView";
import { ViewerComponent } from "./components/ViewerComponent";
import { setReferences } from "./actions/referencesActions";

class ViewerRouteComponent extends RouteHandler {
  static async requestState(requestParams, globalResources) {
    const { sharedId } = requestParams.data;
    const [entity] = await EntitiesAPI.get(
      requestParams.set({ sharedId, omitRelationships: true })
    );
    return entity.documents.length ?
    PDFViewComponent.requestState(requestParams, globalResources) :
    EntityView.requestState(requestParams, globalResources);
  }

  componentWillUnmount() {
    this.emptyState();
  }

  emptyState() {
    this.context.store.dispatch(actions.unset('viewer/doc'));
    this.context.store.dispatch(actions.unset('viewer/templates'));
    this.context.store.dispatch(actions.unset('viewer/thesauris'));
    this.context.store.dispatch(actions.unset('viewer/relationTypes'));
    this.context.store.dispatch(actions.unset('viewer/rawText'));
    this.context.store.dispatch(formActions.reset('documentViewer.tocForm'));
    this.context.store.dispatch(actions.unset('viewer/targetDoc'));
    this.context.store.dispatch(setReferences([]));
    this.context.store.dispatch(actions.unset('entityView/entity'));
    this.context.store.dispatch(relationships.emptyState());
  }

  urlHasChanged(nextProps) {
    const { sharedId: oldSharedId, lang: oldLang } = nextProps.params;
    const { sharedId: newSharedId, lang: newLang } = this.props.params;
    const file = new URLSearchParams(this.props.location.search).get('file');
    const nextFile = new URLSearchParams(nextProps.location.search).get('file');
    const sameQueryFile = file === nextFile;

    if (newSharedId === oldSharedId && newLang === oldLang && sameQueryFile) {
      return false;
    }

    return super.urlHasChanged(nextProps) || !sameQueryFile;
  }

  selectTab({ tabView = 'metadata' }) {
    this.context.store.dispatch(actions.set('viewer.sidepanel.tab', tabView));
    this.context.store.dispatch(showTab(tabView === 'metadata' ? 'info' : tabView));
  }

  render() {
    trackPage();
    this.selectTab(this.props.params);
    return (/*#__PURE__*/
      _jsx(ErrorBoundary, { error: this.state.loadingError }, void 0, /*#__PURE__*/
      React.createElement(ViewerComponent, this.props)
      ));

  }
}

ViewerRouteComponent.defaultProps = {
  params: {}
};
const ViewerRoute = Object.assign(withRouter(ViewerRouteComponent), {
  requestState: ViewerRouteComponent.requestState
});

export { ViewerRouteComponent, ViewerRoute };
export default ViewerRoute;